<template>
	<div class="step-three">
		<stepHeader msg="Välj Betalsätt" :currentStep="3" :maxStep="4" :useSubtitle="! isActive" :useBackgroundColor="! isActive && ! selectedPaymentMethodId || activeStep < 3" />
		<div v-if="availablePaymentMethods.length > 0 && isActive || selectedPaymentMethodId && activeStep > 2" class="col-xs-12 p-0">
			<div class="col-xs-12 list-group">
				<div v-for="(paymentMethod, index) in availablePaymentMethods" :key="paymentMethod.id">
					<paymentMethodItem
						@click.native="selectPaymentMethod(paymentMethod.id, ! isActive, true)"
						:isActive="isActive"
						:paymentMethod="paymentMethod"
						:selectedVoucherType="selectedVoucherType"
						:pendingAmount="pendingAmount"
						:selectedPaymentMethodId="selectedPaymentMethodId"
						:resursPaymentOptions="resursPaymentOptions"
						:totalCartSum="totalCartSum"
						@update:selectedPaymentMethod="v => $emit('update:selectedPaymentMethod', v)"
						:selectedPaymentOption.sync="selectedPaymentOption"
						:isLastRow="index === (availablePaymentMethods.length - 1)"
						:isCorporateCustomer="isCorporateCustomer"
						:selectFirstPartPaymentOption="selectFirstPartPaymentOption"
					/>
					<div v-if="isActive" class="col-xs-12" :class="selectedPaymentMethodId == paymentMethod.id || index === (availablePaymentMethods.length - 1) ? '' : 'border-bottom'"></div>
				</div>
			</div>
			<text-button
				v-if="isActive"
				class="continue-btn"
				text="Fortsätt"
				:disabled="continueDisabled"
				@click="finished"
			/>
		</div>
	</div>
</template>

<script>
import bus from 'eventbus';
import alert from 'alert';
import stepHeader from './step-header';
import paymentMethodItem from './payment-method-item';
import localSessionStorage from 'localSessionStorage';
import { mapGetters, mapState } from 'vuex';
import { selectCheckoutOption } from 'gtm';
import { isEqual, remove } from 'lodash';
import abTest from 'abTest';

export default {
	data() {
		return {
			availablePaymentMethods: [],
			selectedPaymentMethodId: null,
			selectedVoucherType: null,
			pendingAmount: 0,
			defaultPaymentMethods: null,
			giftCardPayment: [],
			storeCreditPayment: [],
			firstLoad: true,
			selectedPaymentOption: null,
			abTest,
			selectFirstPartPaymentOption: false,
		};
	},
	props: {
		isActive: {
			type: Boolean,
			default: false,
		},
		testConstraint: {
			type: Function,
		},
		isStoreReservation: {
			type: Boolean,
		},
		isCorporateCustomer: {
			type: Boolean,
			required: true,
		},
		selectedShippingMethodId: {},
		selectedPayment: {},
		activeStep: {
			type: Number,
		},
		vouchers: {
			type: Array,
		},
		stockAvailability: {
			type: Boolean,
		},
		orderTotalSum: {
			type: Number,
		},
		resursPaymentOptions: {
			type: Array,
			default: [],
		},
		totalCartSum: {
			type: Number
		},
	},
	components: {
		stepHeader,
		paymentMethodItem,
	},
	beforeCreate() {
		waja.get('payment-method/options/24')
			.useCdn(true)
			.on('success', res => {
				this.giftCardPayment = res.data.payment_method ? [res.data.payment_method]  : [];
			}).go();
		waja.get('payment-method/options/27')
			.useCdn(true)
			.on('success', res => {
				this.storeCreditPayment = res.data.payment_method ? [res.data.payment_method]  : [];
			}).go();
		waja.get('payment-method/options')
			.useCdn(true)
			.on('success', res => {
				if (res.data !== null) {
					this.defaultPaymentMethods = res.data.payment_methods;
					this.defaultPaymentMethods[28].options.forEach(opt => {
						if (this.user.settings.b2b_no_invoice_fee == true) {
							opt.invoiceFee = 0;
						} else {
							opt.invoiceFee = 39;
						}
					});
				}
			}).go();
	},
	mounted() {
		bus.$on('update:availablePaymentMethods', this.setPendingAmount);
		this.defaultPaymentMethod();
	},
	beforeDestroy() {
		bus.$off('update:availablePaymentMethods', this.setPendingAmount);
	},
	methods: {
		setPendingAmount (values) {
			this.pendingAmount = values.amount;
			this.getAvailablePaymentMethods(values.activateStep);
		},
		finished () {
			if (this.selectedPaymentMethodId) {
				bus.$emit('stepUpdated', 4, this.selectedPaymentMethodId);
				bus.$emit('selectedPayment', this.selectedPaymentMethodId);
				this.$emit('update:selectedPaymentMethod', this.selectedPaymentMethodId);
			} else {
				alert('Vänligen välj ett betalsätt');
			}
		},
		selectPaymentMethod (itemId, activate = false, IsClick = false) {
			// If resurs faktura is selected, don't add payment option
			if (itemId == 34) {
				this.selectedPaymentOption = null;
			}
			if (itemId == 35) {
				this.selectFirstPartPaymentOption = true;
			} else {
				this.selectFirstPartPaymentOption = false;
			}

			if (! this.isActive && activate) {
				bus.$emit('stepUpdated', 3, null);
			} else if (this.selectedPaymentMethodId !== itemId) {
				this.selectedPaymentMethodId = itemId;
				if (IsClick) {
					selectCheckoutOption(3, this.methodName);
				}
				localSessionStorage.set('checkout:selectedPaymentMethod', itemId);
			}
		},
		defaultPaymentMethod () {
			if (! this.availablePaymentMethods.length) {
				this.selectedPaymentMethodId = null;
				this.$emit('update:selectedPaymentMethod', null);
			}
			let savedMethod = localSessionStorage.get('checkout:selectedPaymentMethod');
			if (savedMethod) {
				savedMethod = parseInt(savedMethod);
			}
			const def = this.isStoreReservation ? 2 : 20;
			// Webhallen delbetalning is not allowed to show up as preselected, so we change to default.
			if (this.firstLoad && (savedMethod == 34 || savedMethod == 35)) {
				savedMethod = def;
			}

			this.firstLoad = false;

			let defaultMethod = null;
			for (const meth of this.availablePaymentMethods) {
				if (meth.disabled) {
					break;
				}
				if (meth.id === def) {
					defaultMethod = meth;
				}
				if (meth.id === savedMethod && this.isActive) {
					this.selectedPaymentMethodId = meth.id;
					return;
				}
			}
		},
		getAvailablePaymentMethods (activate = false) {
			if (this.defaultPaymentMethods) {
				if (this.pendingAmount === 0 && this.availablePaymentMethods[0] && this.selectedVoucherType) {
					this.availablePaymentMethods = this.selectedVoucherType;
					// 24 = Presentkort/giftCard, 27 = Tillgodo/storCredit
					if (this.selectedPaymentMethodId !== 24 || this.selectedPaymentMethodId !== 27) {
						this.selectPaymentMethod(this.availablePaymentMethods[0].id, activate);
					}
				} else {
					let availOpts = [];
					this.sortedPaymentMethods.forEach(el => {
						const method = this.defaultPaymentMethods[el];
						if (! method) {
							return;
						}

						if (this.testConstraint('paymentMethod', method.id) && method.id !== 24) {
							availOpts.push(method);
						}
					});
					// Remove part payment if there is no options
					if (! this.resursPaymentOptions.length) {
						availOpts = availOpts.filter((opt) => opt.id !== 34 && opt.id !== 35 && opt.id !== 36);
					} else if (! this.resursPaymentOptions.some(option => option.monthlyCost)) {
						availOpts = availOpts.filter((opt) => opt.id !== 35);
					}

					// Remove pay later if the campaign is offline
					if (! this.resursPaymentOptions.some(option => option.code === '11')) {
						availOpts = availOpts.filter((opt) => opt.id !== 36);
					}

					this.availablePaymentMethods = availOpts;

					if (this.selectedPaymentMethodId == 24) {
						this.selectPaymentMethod(this.availablePaymentMethods[0].id, activate);
					}
				}
			}
		}
	},
	computed: {
		sortedPaymentMethods () {
			const unsorted = [1,2,3,4,5,6,7,8,9,10,11,12]; // default unsorted
			const sorted = this.user.paymentSuggestions.slice();

			let defaultSorting = [26, 2, 7, 28, 29, 20, 35, 34, 36, 16, 24, 32, 10];

			// If the total price is over 60 000kr, remove resurs payments
			if (this.totalCartSum > 60000) {
				const index = defaultSorting.indexOf(35)
				if (index > -1) {
					defaultSorting.splice(index, 2);
				}
			}

			if(this.abTest.paymentSwap > 0) {
				[defaultSorting[0], defaultSorting[5]] = [defaultSorting[5], defaultSorting[0]]
			}

			const sortedCopy = sorted.slice();

			if (! isEqual(sortedCopy,unsorted)) { // if suggestions are not sorted in default sorting then we can assume that they are sorted in a specific way. Therefore return without changing.
				[defaultSorting[4], defaultSorting[5]] = [defaultSorting[5], defaultSorting[4]];
				const concatinated = sortedCopy.concat(sorted);

				if (this.isStoreReservation) {
					remove(concatinated, (id) => { return id === 2; });
					concatinated.unshift(2);
				}

				remove(defaultSorting, (id) => { return id === concatinated[0]; }); // Remove top option from default array and
				defaultSorting.unshift(concatinated[0]);

				return defaultSorting;
			}

			defaultSorting = defaultSorting.filter(el => {
				return sorted.map(m => {return m;}).indexOf(el) >= 0;
			}).reverse();

			sorted.sort(function(a, b) {
				return defaultSorting.indexOf(a) - defaultSorting.indexOf(b);
			});

			if (this.isStoreReservation) {
				remove(sorted, (id) => { return id === 2; });
				sorted.push(2);
			}

			return sorted.reverse();
		},
		continueDisabled () {
			let currentPaymentMethod = this.availablePaymentMethods.find(element => element.id === this.selectedPaymentMethodId);

			if (this.selectedPaymentMethodId) {
				return currentPaymentMethod?.options.length > 0 && ! this.selectedPaymentOption;
			} else {
				return true;
			}
		},
		methodName () {
			const currentMethod = this.availablePaymentMethods.find(method => method.id == this.selectedPaymentMethodId);

			return currentMethod?.name ?? 'not available';
		},
		...mapState({
			user: state => state.user
		}),
		...mapGetters({
			isLoggedIn: 'user/isLoggedIn',
		}),
	},
	watch: {
		isActive () {
			if (this.isActive) {
				if (! this.selectedShippingMethodId && ! this.isStoreReservation) {
					bus.$emit('stepUpdated', 2, null);
				}
				this.getAvailablePaymentMethods();
			}
		},
		isCorporateCustomer () {
			this.selectedPaymentMethodId = null;
		},
		availablePaymentMethods (avail) {
			const value = this.selectedPaymentMethodId;
			for (const pm of avail) {
				if (pm.value === value) {
					return;
				}
			}
			// Om valt betalsätt inte finns bland tillgängliga så byter vi till första bästa
			this.defaultPaymentMethod();
		},
		isStoreReservation () {
			this.getAvailablePaymentMethods();
			this.defaultPaymentMethod();
		},
		selectedPayment (to) {
			if (to != this.selectedPaymentMethodId) {
				this.selectedPaymentMethodId = to;
			}
		},
		selectedPaymentMethodId (to,frm) {
			if (to !== frm) {
				this.$emit('stepSelection', { 3: this.methodName });
				bus.$emit('selectedPayment', to);
			}
		},
		vouchers (to) {
			this.selectedVoucherType = this.storeCreditPayment;

			// Checks the array of vouchers to set correct payment method when cartSum = 0
			if (to.length) {
				for (let i = 0; i < to.length; i++) {
					if (to[i].type === 'storeCredit' && to.length === 1) {
						this.selectedVoucherType = this.storeCreditPayment;
					} else {
						this.selectedVoucherType = this.giftCardPayment;
					}
				}
			}
			this.getAvailablePaymentMethods();
		},
		stockAvailability () {
			this.getAvailablePaymentMethods();
		},
		selectedPaymentOption (to) {
			bus.$emit('selectedPaymentOption', to);
		},
		resursPaymentOptions () {
			if (this.resursPaymentOptions.length > 2) {
				this.getAvailablePaymentMethods();
			} else {
				this.getAvailablePaymentMethods();
				this.selectPaymentMethod(null);
			}
		},
	},
};
</script>
